<template>
<div id="pagos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Pagos de Clientes" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="pagos.camposexcel" name="Pagos.xlsx" >
                            <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" @click.native="modal = false" >cancel</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Pago</strong>
                                        </span>
                                    </v-card>

                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-autocomplete v-model="model.cliente" :items="clientes" :hide-no-data="true" :hide-selected="true" :return-object="true" :item-text="concatenaCliente" item-value="id_cliente" @change="migrupo()" label="Selecciona un Cliente" :rules="[rules.required]" ></v-autocomplete>
                                                    <code>{{grupo}}</code>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field name="folio_factura" label="Folio de Factura" type="text" v-model="model.folio_factura" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-row align="center" >
                                                <v-col class="d-flex" cols="12" sm="6" >
                                                    <v-menu offset-x  ref="menu1" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_factura"  @change="calcularFecha(meses)" label="Fecha de Facturación" color="secondary" prepend-icon="event" @blur="model.fecha_factura = parseDate(model.fecha_factura)" v-mask="'####-##-##'" :rules="[rules.required]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="model.fecha_factura" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu3 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>

                                                </v-col>

                                                <v-col class="d-flex" cols="12" sm="6" >
                                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_pago"  @change="calcularFecha(meses)" label="Fecha de Pago" color="secondary" prepend-icon="event" @blur="model.fecha_pago = parseDate(model.fecha_pago)" v-mask="'####-##-##'" :rules="[rules.required]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="model.fecha_pago" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>

                                                </v-col>
                                            </v-row>
                                            <v-row align="center" >
                                                <v-col class="d-flex" cols="12" sm="4" >
                                                    <v-select v-model="model.meses" :items="periodos" label="Periodo de Pago" @change="calcularFecha(model.meses)" dense width="50px" ></v-select>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col class="d-flex" cols="12" sm="6" >
                                                    <v-menu offset-x ref="menu1" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_siguiente_factura" label="Siguiente Fecha de Facturación" color="secondary" prepend-icon="event" @blur="model.fecha_siguiente_factura = parseDate(model.fecha_siguiente_factura)" v-mask="'####-##-##'" :rules="[rules.required]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="model.fecha_siguiente_factura" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu4 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                               

                                                <v-col class="d-flex" cols="12" sm="6" >

                                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_vencimiento" label="Fecha de Vencimiento" color="secondary" prepend-icon="event" @blur="model.fecha_vencimiento = parseDate(model.fecha_vencimiento)" v-mask="'####-##-##'" :rules="[rules.required]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="model.fecha_vencimiento" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu2 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-textarea rows="1" label="Observaciones" auto-grow v-model="model.observaciones" :rules="[rules.required]" ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="pagos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="rfc" slot-scope="props" >
                                    <span>{{ props.row.cliente!=null ? props.row.cliente.identificador : "" }}</span>
                                </template>
                                <template slot="nombre" slot-scope="props" >
                                    <span>{{ props.row.cliente!=null ? props.row.cliente.nombre : "" }}</span>
                                </template>

                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id_pago_cliente)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_pago_cliente)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {},
    data: vm => ({
        grupo:"",
        name: "datagrid",
        periodos: [{
                'text': '1 Mes',
                value: 1
            }, {
                'text': '2 Meses',
                value: 2
            }, {
                'text': '3 Meses',
                value: 3
            }, {
                'text': '4 Meses',
                value: 4
            }, {
                'text': '5 Meses',
                value: 5
            }, {
                'text': '6 Meses',
                value: 6
            },
            {
                'text': '12 Meses',
                value: 12
            }, {
                'text': '24 Meses',
                value: 24
            }, {
                'text': '36 Meses',
                value: 36
            }
        ],
        columns: [
            "rfc",
            "nombre",
            "fecha_pago",
            "folio_factura",
            "fecha_factura",
            "fecha_vencimiento",
            "fecha_siguiente_factura",
            "observaciones",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "rfc",
                "nombre",
                "fecha_pago",
                "folio_factura",
                "fecha_factura",
                "fecha_vencimiento",
                "fecha_siguiente_factura",
                 "observaciones",
            ],
            sortable: [
                "rfc",
                "nombre",
                "fecha_pago",
                "folio_factura",
                "fecha_factura",
                "fecha_vencimiento",
                "fecha_siguiente_factura",
            ],
            orderBy: { column: 'fecha_pago', ascending:false },
            headings: {
                rfc: "RFC o TAX ID",
                nombre: "Cliente",
                fecha_pago: "Fecha Pago",
                factura: "Factura",
                fecha_factura: "Fecha Facturación",
                fecha_vencimiento: "Fecha Vencimiento",
                fecha_siguiente_factura: "Siguiente Fecha de Facturación",
                observaciones: "Observaciones",
                actions: "Operaciones"
            }
        },
        URL: "",
        show_loading: true,
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        periodo: null,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Pagos de Clientes",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        grupos:[],
        title: "",
        modal: false,
        update: false,
        pagination: {
            descending: true,
            sortBy: "fecha_pago"
        },
        search: "",
        model: {
            id_pago_cliente: 0,
            fecha_pago: null,
            folio_factura: "",
            fecha_vencimiento: null,
            observaciones: "",
            fecha_factura:"",
            fecha_siguiente_factura:"",
            meses: 1,
            cliente: 0
        },
        clientes: [],
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        pagos: {
            selected: [],
            headers: [{
                    text: "RFC o TAX ID",
                    value: "cliente.identificador",
                    width: "10%"
                },
                {
                    text: "Cliente",
                    value: "cliente.nombre"
                },
                {
                    text: "Fecha Pago",
                    value: "fecha_pago",
                    align: "center",
                    width: "10%"
                },
                
                {
                    text: "Factura",
                    value: "folio_factura",
                    align: "center",
                    width: "10%"
                },
                {
                    text: "Fecha Factura",
                    value: "fecha_factura",
                    align: "center",
                    width: "10%"
                },
                {
                    text: "Fecha Vencimiento",
                    value: "fecha_vencimiento",
                    align: "center",
                    width: "10%"
                },
                {
                    text: "Fecha Siguiente Pago",
                    value: "fecha_siguiente_pago",
                    align: "center",
                    width: "10%"
                },
                 {
                    text: "Periodo",
                    value: "meses",
                    align: "center",
                    width: "10%"
                },
                {
                    text: "Observaciones",
                    value: "observaciones",
                    align: "center",
                    width: "20%"
                }
            ],
            camposexcel: {
                RFC: "cliente.identificador",
                Cliente: "cliente.nombre",
                "Fecha de Pago": "fecha_pago",
                Factura: "folio_factura",
                "Fecha Factura": "fecha_factura",
                "Fecha de Vencimiento": "fecha_vencimiento",
                "Fecha Sigiente Pago": "fecha_siguiente_pago",
                Observaciones: "observaciones"
            },
            items: [0]
        }
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.pagos.items;
            }

        },
    },
    methods: {
        migrupo(grupo){
            
            var grupos = this.grupos;
        
            if(this.model.cliente.id_cliente >0){
                const ix_grupo =  grupos.findIndex(c => c.id_grupo===this.model.cliente.grupo );
                if(ix_grupo>0)
                    this.grupo="Pertenece al grupo: " +grupos[ix_grupo].nombre;
                else
                    this.grupo= "No tiene Grupo";
            }else this.grupo= "";
            
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        calcularFecha: function (meses) {
            var fecha = moment(this.model.fecha_pago);
            var fecha_f = moment(this.model.fecha_factura);
            fecha.add(meses, "months");
            fecha_f.add(meses, "months");
            this.model.fecha_vencimiento = this.parseDate(fecha);
            this.model.fecha_siguiente_factura = this.parseDate(fecha_f);
        },
        
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Registro de Pago";
                this.update = false;
            } else {
                this.title = "Actualizar Registro de Pago";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.periodo = 1;
            this.grupo=""
            //Fecha actual
            this.model.fecha_pago = this.parseDate(
                new Date().toISOString().substr(0, 10)
            );
            this.model.fecha_factura= this.parseDate(
                new Date().toISOString().substr(0, 10)
            );
        },

        concatenaCliente: item => item.identificador + " - " + item.nombre,

        guardar() {
            let cliente = this.model.cliente
            this.model.cliente = cliente.id_cliente;
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$swal({
                    type: "warning",
                    title: "Confirmar!!",
                    text: "Este registro actualizará la Fecha de Vencimiento del Cliente " + cliente.nombre + " a: " + this.model.fecha_vencimiento +
                        " ¿Desea continuar?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Si",
                    cancelButtonText: "No"
                }).then(result => {
                    if (result.value) {
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        var metodo = "post";
                        var urlCliente = this.URL;
                        if (this.update == true) {
                            metodo = "put";
                            urlCliente += this.model.id_pago_cliente + "/";
                        }
                        axios({
                                method: metodo,
                                url: urlCliente,
                                data: datos
                            })
                            .then(res => {
                                this.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "Los datos se guardaron correctamente",
                                    footer: ""
                                });
                            })
                            .catch(error => {
                                 this.model.cliente =cliente;
                                this.$swal({
                                    position: "center",
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al guardar los datos"
                                    //showConfirmButton: false,
                                });
                                console.log(error);
                            })
                            .then(() => {
                                this.cargar();
                                this.$root.$dialogLoader.hide();
                                this.modal = false;
                            });
                    } else {
                         this.model.cliente =cliente;
                        return false;
                    }
                });
            }
        },

        cargar: function () {
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.pagos.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getClientes: function () {
            axios
                .get(this.$hostname + "clientes/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientes = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getGrupos: function () {
            axios
                .get(this.$hostname + "grupos/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.grupos = res.data;
                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro" + error,
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        } //delete
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/pagos/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.getClientes();
        this.getGrupos();
        
    }
};
</script>
